import { getRequest, updateRequest } from "./api.service";
import { API_URL } from "../utils/constants";
import { updateData } from "./review.service";

export enum TeacherStatus {
  REGISTERED = "registered",
  ACCEPTED = "accepted",
  VERIFIED = "verified",
  SUSPENDED = "suspended",
  REJECTED = "rejected",
  DEACTIVATED = "deactivated",
}

export const getTotalTeachersByStatus = async (): Promise<any> => {
  const data = await getRequest<{ result: { users: number } }>(
    `${API_URL}/teachers/count-by-status`
  );
  return data.result;
};

export const updateTeacherStatus = async (
  endpoint: string,
  body: { status: TeacherStatus }
) => {
  const data = await updateRequest<{ id: number }>(
    `${API_URL}/${endpoint}`,
    body
  );
  return data;
};

export const getDetails = async <T>(endpoint: string): Promise<T> => {
  const data = await getRequest<T>(`${API_URL}/${endpoint}`);
  return data;
};
